import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import toast from "react-hot-toast";
import ajaxStationSales from "../../util/remote/ajaxStationSales";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);
export default function CompanyStationSalesBarChart() {
  const company_id = Number(window.localStorage.getItem("FuelFy@company_id"));
  const getCurrentMonth = () => {
    const d = new Date();
    return `${d.getFullYear()}${String(d.getMonth() + 1).padStart(2, "0")}`;
  };
  const [month, setMonth] = useState(getCurrentMonth());
  const [chartData, setChartData] = useState({ labels: [], datasets: [] });
  const fetchSales = async () => {
    const response = await ajaxStationSales.monthly_sales_per_station_graph({
      company_id,
      month,
    });
    const data = response?.details;
    if (response?.status === "OK" && Array.isArray(data)) {
      const labels = data.map((item) => item.station_name);
      const litres = data.map((item) => Number(item.total_litres));
      const amounts = data.map((item) => Number(item.total_amount));
      setChartData({
        labels,
        datasets: [
          {
            label: "Total Liters Sold",
            data: litres,
            backgroundColor: "#0a68baff",
            borderRadius: 6,
            yAxisID: "yLitres",
          },
          {
            label: "Total Revenue (UGX)",
            data: amounts,
            backgroundColor: "#f7ff07ff",
            borderRadius: 6,
            yAxisID: "yRevenue",
          },
        ],
      });
    } else {
      toast.error(response.message);
    }
  };
  useEffect(() => {
    if (company_id) fetchSales();
  }, [month]);
  return (
    <div className="container-fluid">
      <h2 className="mb-3">Monthly Sales Per Station</h2>
      {/* Month Selector */}
      <div className="mb-4">
        <label className="fw-medium me-2">Select Month:</label>
        <input
          type="month"
          value={`${month.slice(0, 4)}-${month.slice(4, 6)}`}
          onChange={(e) => {
            const [yr, mn] = e.target.value.split("-");
            setMonth(`${yr}${mn}`);
          }}
          className="form-control d-inline-block"
          style={{ width: "200px" }}
        />
      </div>
      {/* Responsive Chart Container */}
      <div
        className="w-100"
        style={{
          height: "380px",
        }}
      >
        <Bar
          data={chartData}
          options={{
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: { position: "top" },
              datalabels: {
                anchor: "end",
                align: "start",
                rotation: -90,
                color: "#000",
                font: { weight: "bold", size: 12 },
                formatter: (value) => value.toLocaleString(),
              },
            },
            scales: {
              yLitres: {
                type: "linear",
                position: "left",
                beginAtZero: true,
                title: { display: true, text: "Liters Sold" },
              },
              yRevenue: {
                type: "linear",
                position: "right",
                beginAtZero: true,
                title: { display: true, text: "Revenue (UGX)" },
                grid: { drawOnChartArea: false },
              },
              x: {
                title: { display: true, text: "Stations" },
              },
            },
          }}
        />
      </div>
    </div>
  );
}
